import { render, staticRenderFns } from "./TabInformationsPeople.vue?vue&type=template&id=0ea3bbfe&scoped=true&"
import script from "./TabInformationsPeople.vue?vue&type=script&lang=js&"
export * from "./TabInformationsPeople.vue?vue&type=script&lang=js&"
import style0 from "./TabInformationsPeople.vue?vue&type=style&index=0&id=0ea3bbfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea3bbfe",
  null
  
)

export default component.exports